import bodyLockService from "../ui/bodyLockService";

const legacyModal = {
    $body: null,
    $trigger: null,
    $closeBtns: null,
    $modalClickZone: null,
    $activeItem: null,
    classes: {
        modalActive: 'modal_isActive',
        bodyActive: 'modalIsOpen',
    },
    init: function () {
        this.$body = $('body:not(.quoteHelp)');
        this.$trigger = this.$body.find('.js-modalTrigger');
        this.$closeBtns = this.$body.find('.js-modalClose');
        this.$modalClickZone = this.$body.find('.modal-click-zone');

        this.bindEvents();
    },
    bindEvents: function () {
        var clickEvent = 'ontouchstart' in document.documentElement ? 'touchstart click' : 'click';

        var handleModalTriggerClick = $.proxy(this.onModalTriggerClick, this);
        var handleCloseBtnClick = $.proxy(this.onCloseBtnClick, this);
        // var handleBodyClick = $.proxy(this.onBodyClick, this);
        var handleModalClick = $.proxy(this.onModalClick, this);


        this.$trigger.on('click', handleModalTriggerClick);
        this.$closeBtns.on('click', handleCloseBtnClick);
        // this.$body.on('click', handleBodyClick);
        this.$modalClickZone.on('click', handleModalClick);
    },
    onModalClick: function (e) {
        e.stopPropagation();
    },
    onModalTriggerClick: function (e) {
        var $this = $(e.currentTarget)
        var $modalTarget = this.$body.find($this.data('modalTarget'));

        e.preventDefault();
        e.stopPropagation();

        $modalTarget.toggleClass(this.classes.modalActive);
        this.$body.toggleClass(this.classes.bodyActive);
        bodyLockService.lock();

        if (this.$activeItem && this.$activeItem.is($modalTarget)) {
            this.clearActiveItem();
            bodyLockService.unlock();
            return;
        }

        this.clearActiveItem();
        this.$activeItem = $modalTarget;
    },
    onCloseBtnClick: function (e) {
        this.clearActiveItem();
        bodyLockService.unlock();
        e.preventDefault();
        e.stopImmediatePropagation();
    },
    // onBodyClick: function (e) {
    //     this.clearActiveItem();
    //     bodyLockService.unlock();
    // },
    clearActiveItem: function () {
        if (this.$activeItem) {
            this.$activeItem.removeClass(this.classes.modalActive);
            this.$activeItem = null;
        }
    },
    // lockBody: function () {
    //     bodyLockService.lock();
    //     this.modalActive = true;
    // },
    // unlockBody: function () {
    //     if (!this.modalActive) {
    //         return;
    //     }
    //     bodyLockService.unlock();
    //     this.modalActive = false;
    // }
}
legacyModal.init();